
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/anchors/components/StageAnchorsContainer.scss.css.virtualfile';
        module.exports = {"anchorsContainer":"_anchorsContainer_wq9on_1","mobileEditor":"_mobileEditor_wq9on_6","fixed":"_fixed_wq9on_6"};